<template>
  <div class="context">
    <!-- <div class="cardheard">

      <div>
          <el-select style="width:200px;margin-right: 20px;" v-model="req.query.type" placeholder="请选择分类">
            <el-option v-for="item in options2" :key="item.id" :label="item.typeName" :value="item.id">
            </el-option>
          </el-select>
        </div>
    </div> -->

    <el-container>
      <el-header width="500px">
        <div class="head">
          <div>
            <div class="money">
              <div class="moneyItem">
                <div class="number moneynumber">当前余额</div>
                <div class="name">￥{{moneyData.money}}</div>
              </div>
              <div class="moneyItem">
                <div class="number moneynumber">冻结中</div>
                <div class="name">￥{{moneyData.unusable}}</div>
              </div>
            </div>
          </div>

          <div class="moneyItem">
            <div>
              <el-link>充值></el-link>
            </div>
            <div class="font">
              <el-link type="primary">立即提现></el-link>
            </div>
            <el-link type="primary">提现记录></el-link>
            <div></div>
          </div>
        </div>
      </el-header>
      <el-main>
        <!-- <div>
      <el-table v-model="data" :data="data" style="width: 100%" height="400px" v-loading="loading">
        <el-table-column type="index" width="50">
        </el-table-column>

        <el-table-column label="余额变动" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.money }}</span>
          </template>
        </el-table-column>
      
        <el-table-column label="账单类型" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.money }}</span>
          </template>
        </el-table-column>

        <el-table-column label="收益状态" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.money }}</span>
          </template>
        </el-table-column>
      

        <el-table-column label="时间"  width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>

      </el-table>

    </div> -->

        <div>
          <el-table
            v-model="data"
            :data="data"
            style="width: 100%"
            height="300px"
            v-loading="loading"
          >
            <el-table-column type="index" width="50" label="序号"> </el-table-column>

            <el-table-column label="变动金额" width="100">
              <template slot-scope="scope">
                <!-- <span>￥{{ scope.row.money }}</span> -->
                <el-tag type="success" v-if="scope.row.type==1">+{{ scope.row.money }}</el-tag>
                <el-tag type="danger" v-if="scope.row.type==0">-{{ scope.row.money }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="账单类别" >
          <template slot-scope="scope">
            <el-tag type="info">{{ scope.row.billTypeName }}</el-tag>
          </template>
        </el-table-column>

            <!-- <el-table-column label="当前状态">
              <template slot-scope="scope">
                <span>{{ scope.row.money }}</span>
              </template>
            </el-table-column> -->

            <el-table-column label="备注">
              <template slot-scope="scope">
                <span>{{ scope.row.remake }}</span>
              </template>
            </el-table-column>

            <el-table-column label="账单时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next"
            :total="10000"
          >
          </el-pagination>
        </div>
      </el-main>
    </el-container>

    <!-- <template>
    </template>

    <div v-if="modelShow">
      <UserUpdateorAdmin :dialogShow="modelShow" ref="userModel" @pushdata="pushdata" @modelChange="userShowChange" />
    </div> -->
  </div>
</template>

<script>
import store from "@/store/";
import UserUpdateorAdmin from "../components/userUpdateorAdmin.vue";

export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      moneyData:{
        money:"0.00",
        unusable:"0.00"
      },
      time: "",
      loading: true,
      req: {
        parma: "",
        pageIndex: 0,
        pageCount: 10,
        query: {
          sysUserId: "",
          type: "",
        },
      },
      data: [],
      modelShow: false,
      options2: [
        { id: -1, typeName: "全部" },
        { id: 1, typeName: "充值" },
        { id: 0, typeName: "人脸认证" },
      ],
    };
  },
  mounted() {
    this.req.query.sysUserId = this.$store.state.user.user.id;
    this.pushdata()
    this.getMoney()
  },
  methods: {
    getMoney(){
      var that =this
      that.$axios
        .get("/api2/business/getMyMoney/"+this.$store.state.user.user.id, {})
        .then(function (response) {
          that.moneyData = response.data.data;
        });
    },
    
    reset() {
      this.time = [];
      this.req = {
        parma: "",
        pageIndex: 0,
        pageCount: 10,
        query: {
          sysUserId: "",
          name: "",
        },
      };
      this.req.query.sysUserId = this.$store.state.user.user.id;
    },
    clear() {
      this.reset();
      this.pushdata();
    },
    selectByQuery() {
      if (this.time) {
        this.req.startTime = this.time[0];
        this.req.endTime = this.time[1];
      }
      this.req.pageIndex = 0;
      this.pushdata();
    },
    updateUser(row) {
      (this.modelShow = true),
        setTimeout(() => {
          this.$refs["userModel"].init(row.id); //用$refs赋值调用子组件的init方法
        }, 500);
    },
    userShowChange(visible) {
      this.modelShow = visible;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      if (val != 1) {
        var statcount = (val - 1) * this.req.pageCount;
        this.req.pageIndex = statcount;
        console.log("当前开始index--" + statcount);
      } else {
        this.req.pageIndex = 0;
        console.log("当前开始index--" + statcount);
      }
      console.log(this.req);
      this.pushdata();
    },
    pushdata() {
      var that = this;
      that.$axios
        .post("/api2/business/getBillByPage", this.req)
        .then(function (response) {
          that.loading = false;
          that.data = response.data.data;
        });
  },
}
};
</script>
<style scope>
.item {
  margin-left: 10px;
}
.moneyItem {
  margin: 20px;
}
.money {
  background-color: rgb(252, 254, 254);

  display: flex;
}
.head {
  display: flex;
  justify-content: space-between;
  background-color: rgb(252, 254, 254);
}
.name {
  font-family: 555;
  font-size: 2vw;
  font-weight: 400;
}

.number {
  font-size: 1.4vw;
  font-weight: 400;
}

.moneynumber {
}
</style>
